import { useEffect, useState } from "react";
import serverPath from "../utils/serverPath";

export default function useMasterPrograms(slug = "", { current = 1, pageSize = 20 } = {}) {
  const key = slug ? encodeURIComponent(slug) : `?current=${current}&pageSize=${pageSize}`;
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ key: "", loading: true, data: null, total: 0, error: false, notFound: false });
  useEffect(() => {
    const controller = new AbortController();
    const reset = { key, loading: false, data: null, total: 0, error: false, notFound: false };
    const timeout = setTimeout(() => { controller.abort(); setState({ ...reset, error: true }); }, 15000);
    setState({ ...reset, loading: true });
    fetch(serverPath(`/api/master-programs${slug ? "/" : ""}${key}`), { signal: controller.signal })
      .then(async (response) => {
        if (response.status === 404) { if (!controller.signal.aborted) setState({ ...reset, notFound: true }); return; }
        if (!response.ok) throw new Error("Program unavailable");
        const payload = await response.json();
        if (payload.status !== "success" || !payload.data) throw new Error("Invalid program response");
        if (!slug && (!Array.isArray(payload.data.items) || !Number.isFinite(payload.data.total))) throw new Error("Invalid program list");
        if (!controller.signal.aborted) setState({ ...reset, data: slug ? payload.data : payload.data.items, total: payload.data.total || 0 });
      }).catch(() => { if (!controller.signal.aborted) setState({ ...reset, error: true }); })
      .finally(() => clearTimeout(timeout));
    return () => { clearTimeout(timeout); controller.abort(); };
  }, [key, slug, attempt]);
  return { ...(state.key === key ? state : { loading: true, data: null, total: 0 }), retry: () => setAttempt((value) => value + 1) };
}
